import http from '../../http'

// 获取用户信息
export const getUserForApp = data => {
    return http(`/admin-api/member/user/getUserForApp`, 'get', data)

}

// 获取用户所有信息
export const getUserInfo = data => {
    return http(`/app-api/rule/user/get-user-info`, 'get', data)

}